import { GET_COMPANY } from './../constants';
import { handleActions } from "redux-actions"

export const company  = handleActions(
  {
    [ GET_COMPANY ]: (state, action) => action.payload,
  }, []
)
